export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 170,
    slots: {
      default: 'opt'
    }
  },
  {
    title: that.$l('table_label_billCartonTransferNo') || '转库单编号',
    field: 'billCartonTransferNo',
    align: 'center',
    minWidth: 140,
    showHeaderOverflow: 'title'
  },
  {
    title: that.$l('table_label_transferDate') || '转库日期',
    field: 'transferDate',
    headerAlign: 'center',
    align: 'left',
    width: 170,
    showHeaderOverflow: 'title'
  },

  {
    title: that.$l('INDEX.Status') || '单据状态',
    minWidth: 100,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    slots: { default: 'status' }
  },

  {
    title: that.$l('table_label_inLocationFullName') || '转入库位名称',
    field: 'inLocationFullName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },

  {
    headerAlign: 'center',
    field: 'createByName',
    title: that.$l('INDEX.creator') || '创建人',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: 'title'
  },
  {
    headerAlign: 'center',
    field: 'createTime',
    title: that.$l('INDEX.create_date') || '创建时间',
    align: 'center',
    minWidth: 170,
    showHeaderOverflow: 'title'
  },
  {
    headerAlign: 'center',
    field: 'modifyByName',
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: 'title'
  },
  {
    headerAlign: 'center',
    field: 'modifyTime',
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    minWidth: 170,
    showHeaderOverflow: 'title'
  }
]
